module.exports = __webpack_public_path__ + "img/blog-01-770x420.a2136a4a.jpg";